// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"228":"902d9525e80dcedb1f16","634":"91dd929b218ea1e495c5","860":"58bbc02a67c0d4ed526c","861":"86dca76766cf2adad95b","873":"79011704945715082fbb"}[chunkId] + ".js";
};